import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "form" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createVNode(_component_el_form, { "label-width": _ctx.labelWidth }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (item) => {
              return (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({
                key: item.label
              }, _ctx.colLayout)), {
                default: _withCtx(() => [
                  (!item.isHidden)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: item.label,
                        rules: item.rules,
                        style: _normalizeStyle(_ctx.itemStyle)
                      }, {
                        default: _withCtx(() => [
                          (item.type === 'input' || item.type === 'password')
                            ? (_openBlock(), _createBlock(_component_el_input, {
                                key: 0,
                                "show-password": item.type === 'password',
                                placeholder: item.placeholder,
                                "model-value": _ctx.modelValue[`${item.field}`],
                                "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                              }, null, 8, ["show-password", "placeholder", "model-value", "onUpdate:modelValue"]))
                            : (item.type === 'select')
                              ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({ key: 1 }, item.otherOptions, {
                                  placeholder: item.placeholder,
                                  style: {"width":"100%"},
                                  "model-value": _ctx.modelValue[`${item.field}`],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                                }), {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: option.value,
                                        value: option.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1040, ["placeholder", "model-value", "onUpdate:modelValue"]))
                              : (item.type === 'datepicker')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({ key: 2 }, item.otherOptions, {
                                    "range-separator": "-",
                                    style: {"width":"100%"},
                                    "model-value": _ctx.modelValue[`${item.field}`],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.handleValueChange($event, item.field))
                                  }), null, 16, ["model-value", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["label", "rules", "style"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["label-width"]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "footer")
    ])
  ]))
}